import React from "react";
import { Link } from "react-router-dom";
function TermsAndConditions({ isSmallScreen }) {
  return (
    <p
      className="text-center px-0 m-0"
      style={{
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: isSmallScreen ? "0.6rem" : "0.7rem",
      }}
    >
      By continuing, you agree to Lookflock's{" "}
      <Link
        style={{ color: "black", textDecoration: "underline" }}
        target="_blank"
        to="/staticPages/termsAndConditions"
      >
        Terms of Service
      </Link>{" "}
      and acknowledge you've read our{" "}
      <Link
        style={{ color: "black", textDecoration: "underline" }}
        target="_blank"
        to="/staticPages/privacyPolicy"
      >
        Privacy Policy
      </Link>
    </p>
  );
}

export default TermsAndConditions;
